import { ILabDiagnosticApiState } from '../types/labDiagnostic.types';

export const LAB_DIAGNOSTIC_INITIAL_STATE: ILabDiagnosticApiState = {
    data: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    pageProps: {
        isDescending: false,
        pageNumber: 0,
        perPage: 0,
        searchText: '',
        sortingOn: '',
    },
    labOrderMaterList: [],
    loading: 'idle',
    error: null,
};
